'use client';
import React from 'react';
import AddOn from '@src/components/AddOn';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import type { MeaterProduct } from '@src/domain/types/MeaterProduct';

interface CompleteSetupProps {
  relatedProducts: Array<MeaterProduct>;
}

const CompleteSetup = ({ relatedProducts }: CompleteSetupProps) => {
  const { t } = useTranslation();

  const availableProducts = relatedProducts.filter((p) =>
    p.variants.some((v) => v.availableForSale),
  );

  if (!availableProducts.length) return null;

  return (
    <div className="flex flex-col gap-5 pt-5">
      <h5 className="tra-text-web-heading-5 text-neutral-700">
        {t('productDetailPageContent.completeSetupText', undefined, {
          default: 'Complete your setup',
        })}
      </h5>
      <div className="flex flex-col gap-3">
        {availableProducts.map((relatedProduct) => {
          return <AddOn key={relatedProduct.handle} product={relatedProduct} />;
        })}
      </div>
    </div>
  );
};

export default CompleteSetup;
